import script from "./StoryThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryThumb.vue?vue&type=script&setup=true&lang=js"

import "./StoryThumb.vue?vue&type=style&index=0&id=4a09f922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a09f922"]])

export default __exports__